import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dmmp-subcontent-links',
  templateUrl: './subcontent-links.component.html'
})
export class SubcontentLinksComponent implements OnInit {
  @Input() identifier
  @Input() links
  @Input() target
  @Input() image
  constructor() { }

  ngOnInit(): void {
  }

}
